<template>
    <div class="header">
        <div class="header-container">
            <div class="hamburger hamburger--spin">
                <div class="hamburger-box">
                    <div class="hamburger-inner"></div>
                </div>
            </div>

            <div class="logo">
                <a href="/">
                    <img src="../../images/placeholder.png" height="40" width="211" alt="">
                </a>
            </div>
            <ul class="header-login-menu hidden-on-mobile">
                <li>
                    <a href="#" v-if="user.info">
                        <i class="la la-user"></i>
                        {{user.info && user.info.user && user.info.user.first_name}}
                    </a>
                    <a href="#" @click.prevent="logout()">
                        ( logout )
                    </a>
                </li>
            </ul>
            <ul class="cf-menu hidden-on-mobile">
                <li>
                     <router-link to="/">Calculator</router-link>
                </li>
            </ul>


        </div>
    </div>
</template>

<script>
    import {LoginAPI} from "../../apis/LoginAPI";
    import store from "../../store"
    import {mapState} from "vuex";

    export default {
        store,
        data() {
            return {}
        },
        props: {},
        methods: {
            async logout() {
                let resp = await LoginAPI.logout();
                if (resp.success) {
                    window.location.href = '/login'
                    // this.$router.push({
                    //     'name': 'users_login'
                    // });
                }
            }
        },
        computed: {
            ...mapState(['user'])
        }
    };
</script>

<style scoped lang="scss">
    .header {

        position: -webkit-sticky; /* Safari */
        position: sticky;
        padding: 20px 0 10px 0;
        top: 0;
        z-index: 999;
        background: #fff;
        border-bottom: 1px solid #eee;
        transition: all 0.3s;

        img, ul, .btn {
            transition: all 0.3s;
        }

        .header-container {
            @media(max-width: 1200px) {
                max-width: 1000px;
            }
            max-width: 1083px;
            margin: auto;
        }

        + div {
            transition: margin-top 0.3s;
        }

        &.sticky {

            + div {
                margin-top: 72px;
            }

            box-shadow: 0 0 6px rgba(153, 153, 153, 0.3);

            .logo {
                margin: 3px 0 0 6px;
            }

            .header-login-menu {
                margin-top: 12px;
                margin-bottom: 6px;
            }

            padding: 2px 0;

            img {
                height: 36px;
                width: 140px;
            }

            ul, .btn-header {
                font-size: 14px;
            }

            .cf-menu {
                margin-top: 12px;
            }
        }

        .logo {
            margin-top: -5px;
            float: left;
        }
    }

    .cf-menu {
        float: right;
        display: flex;
        list-style-type: none;
        margin: 4px 0 0 0;
        font-size: 16px;
        font-weight: 400;

        li {
            display: inline-block;
            padding: 0 14px;
            //border-right: 1px solid #ccc;

            &:last-child {
                border-right: none;
                padding-right: 0;
            }

            a {
                color: #555;

                &:hover {
                    color: #000;
                }
            }
        }
    }

    .header-login-menu {
        float: right;
        margin-top: 4px;
        margin-left: 30px;
        list-style: none;
        padding: 0;
        display: flex;
        font-size: 16px;

        li {
            margin-right: 10px;
        }


        .btn-header {
            padding: 0.2rem 0.6rem;
            font-size: 16px;
            margin-top: -2px;
            line-height: 1.5;
            border-radius: 0.2rem;
        }

    }

</style>
